import ToolTip from "../Components/Interactive/ToolTip";
import CardIcon from "../Utilities/CardIcon"
import EditIcon from "@mui/icons-material/Edit";

const formatPhone = (phone) => {
  let thisPhone = phone;
  let area = thisPhone.slice(0, 3);
  let first = thisPhone.slice(3, 6);
  let last = thisPhone.slice(6, 10);
  return `(${area}) ${first} - ${last}`;
};

const formatDate = (data) => new Date(data).toLocaleString('en-US').split(',').join(' ')
const formatDateOnly = (data) => new Date(data).toLocaleString('en-US').split(',')[0]

const formatCurrency = (price) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  return formatter.format(price);
};

const formatAdjectives = (orderStatus) => {
  if (
    orderStatus !== "Attempt" &&
    orderStatus !== "Success" &&
    orderStatus !== "Cancel" &&
    orderStatus !== "Refund-Attempt" &&
    orderStatus !== "Refund"
  ) {
    return null;
  }
  return orderStatus;
};

const formatFullName = (fName, lName) => {
  let firstName = fName.split("");
  let lastName = lName.split("");

  firstName[0] = firstName[0].toUpperCase();
  lastName[0] = lastName[0].toUpperCase();

  firstName = firstName.join("");
  lastName = lastName.join("");

  return firstName + " " + lastName;
};

const formatMoreInfoProperties = (customerId) => {
  return (
    <ToolTip placement="bottom" titleHeading="Customer ID" titleData={customerId}>
      <div className="user-detail">
        <p style={{ fontSize: "12px", marginRight: "1rem" }}>CID</p>
        <p>{customerId}</p>
      </div>
    </ToolTip>
  );
};

const formatMembershipProperties = (customerMemberships, setCurrentlyEdited, openResetPasswordModal) => {
  return customerMemberships.map((mem, idx) => (
    <div key={idx}>
      {mem.membershipProfileName && <div className="data-highlight" style = {{display: "flex"}}>
        <p>{mem.membershipProfileName}</p>
      <EditIcon className="edit-info-btn" onClick={() => setCurrentlyEdited(idx, mem)} style={{marginRight: "1rem"}}/>
      </div>
      }
      <ToolTip
        placement="left"
        titleHeading="Membership ID"
        titleData={mem.membershipId}
      >
        <div className="data-highlight">
          <h6>User Name</h6>
          <p>{mem.memberUsername}</p>
        </div>
      </ToolTip>
      <div className="data-highlight">
        <h6>Expiration Date</h6>
        <p>{formatDateOnly(mem.memberExpirationDate)}</p>
      </div>
      {mem.memberExperiment && <div className="data-highlight">
          <h6>Experiment Variant</h6>
          <p>{mem.memberExperiment}</p>
      </div>}
      { !mem.active ? (
        <div className="data-highlight">
        <h6 className="red-text">Inactive</h6>
        </div>) : null
       }
      {mem && !mem.membershipProfileName.includes("ID Protect") ? (
        <button
          className="reset-password-btn"
          onClick={() => openResetPasswordModal()}
        >
          <span>Reset Password</span>
        </button>
      ) : null}
      {customerMemberships.length > 1 && idx !== customerMemberships.length - 1 && (
        <div>
          <br/>
          <hr className="hr" />
        </div>
        )}
    </div>
  ));
};

const formatTrackingProperties = (
  ipAddress,
  campaignId,
  scn,
  visitorHash,
  sca,
  leadId,
  c1
) => {
  return (
    <>
      <div className="data-highlight">
        <h6>Campaign Id</h6>
        <p>{campaignId}</p>
      </div>
      <div className="data-highlight">
        <h6>SCN</h6>
        <p>{scn}</p>
      </div>
      <div className="data-highlight">
        <h6>SCA</h6>
        <p>{sca ? sca : "n/a"}</p>
      </div>
      <div className="data-highlight">
        <h6>Visitor Hash</h6>
        <p>{visitorHash}</p>
      </div>
      <div className="data-highlight">
        <h6>IP Address</h6>
        <p>{ipAddress}</p>
      </div>
      <div className="data-highlight">
        <h6>Lead ID</h6>
        <p>{leadId ? leadId : "n/a"}</p>
      </div>
      <div className="data-highlight">
        <h6>C1</h6>
        <p>{c1 ? c1 : "n/a"}</p>
      </div>
    </>
  );
};

const formatPaymentProperties = (
  cardType,
  expirationDate,
  lastFour,
  cardHolder,
  address,
  city,
  state,
  postalCode,
  type,
  isPrepaid,
  bank,
  role
) => {
  // If there is no card type then there is no payment detail to show
  if (!cardType)
    return <h3 style={{ fontSize: "1rem" }}>No Payment Details</h3>;
  const isAdminOrSuperUser = role === "Administrator" || role === "Super User" || role === "Supervisor";
  return (
    <>
      <div className="data-highlight">
        <h6>Card Type</h6>
        <CardIcon cardType={cardType} />
        {isAdminOrSuperUser && isPrepaid && (
          <span
            style={{
              display: "inline-block",
              marginLeft: "1rem",
              color: "grey",
            }}
          >
            This is a prepaid card
          </span>
        )}
      </div>
      <div className="data-highlight">
        <h6>Card Holder</h6>
        <p>{cardHolder ? cardHolder : "n/a"}</p>
      </div>
      <div className="data-highlight">
        <h6>Card Number (last 4 digits)</h6>
        <p>{lastFour ? `**** **** **** ${lastFour}` : "n/a"}</p>
      </div>
      <div className="data-highlight">
        <h6>Expiration Date</h6>
        <p>{expirationDate ? expirationDate : "n/a"}</p>
      </div>
      <div className="data-highlight">
        <h6>Payment Address</h6>
        <p>{address ? `${address} ${city}, ${state}, ${postalCode}` : "n/a"}</p>
      </div>
      {isAdminOrSuperUser && (
        <div className="data-highlight">
          <h6>Payment Type</h6>
          <p>{type ? type : "n/a"}</p>
        </div>
      )}
      {isAdminOrSuperUser && (
        <div className="data-highlight">
          <h6>Payment Bank</h6>
          <p>{bank ? bank : "n/a"}</p>
        </div>
      )}
    </>
  );
};

// Formats email log data
const formatEmailProperties = (emailLogData) => {
  return emailLogData.map((log, idx) => {
    const { email, subject, sentDate } = log;
    return (
      <div className="log-data-container">
        <h6>Email Subject</h6>
        <p>{subject ? subject : "n/a"}</p>
        <h6>Email</h6>
        <p>{email ? email : "n/a"}</p>
        <h6>Date</h6>
        <p>{sentDate ? sentDate : "n/a"}</p>
      </div>
    );
  });
};

// Formats login-history data
const formatLoginHistoryProperties = (loginHistoryData) => {
  return loginHistoryData.map((log, idx) => {
    const { accessDate, ipAddress } = log;
    return (
      <div className="log-data-container">
        <h6>Access Date</h6>
        <p>{accessDate && accessDate ? accessDate : "n/a"}</p>
        <h6>IP Address</h6>
        <p>{ipAddress ? ipAddress : "n/a"}</p>
      </div>
    );
  });
};

/* Formats dollar amounts with decimals in them to two cent places*/
const formatNumber = (program) => Number(program.subscriptionOrderPrice.toFixed(2));

const formatLabels = (status) => {
  switch (status) {
    case "Success":
      return "statusSuccess";
    case "Cancel":
      return "statusCancel";
    case "ACTIVE":
      return "statusSuccess";
    case "INACTIVE":
      return "statusCancel";
    case "Attempt":
      return "statusAttempt";
    case "Refund-Attempt":
      return "statusAttemptRefund";
    case "Refund":
      return "statusRefund";
    case "Customer":
      return "customer";
    case "SPR":
      return "spr";
    case "KLS":
      return "kls";
    case "PIS":
      return "pis";
    case "PDC":
      return "pdc";
    case "SF":
      return "sf";
    case "PRR":
      return "prr";
    case "QPR":
      return "qpr";
    case "PF":
      return "pf";
    default:
      return;
  }
};

const formatBrandName = (brandName) => {
  switch (brandName) {
    case "SF":
    case "PDC":
    case "PIS":
    case "KLS":
    case "SPR":
    case "PRR":
    case "QPR":
    case "PF":
      return brandName;
    default:
      return null;
  }
};

export {
  formatPhone,
  formatNumber,
  formatDate,
  formatAdjectives,
  formatFullName,
  formatMembershipProperties,
  formatTrackingProperties,
  formatPaymentProperties,
  formatLabels,
  formatBrandName,
  formatCurrency,
  formatMoreInfoProperties,
  formatEmailProperties,
  formatLoginHistoryProperties,
};
